import React from 'react';
import {
  Col,
  Card,
  Box,
  Text,
  Button,
  TextButton,
  Image,
} from 'wix-style-react';

export interface OppurtinityCardProps {
  imageUrl: string;
  title: string;
  subtitle: string;
  mainActionText: string;
  secondaryActionText?: string;
  onMainActionClick(): void;
  onSecondaryActionClick?(): void;
}

export const OppurtunityCard: React.FC<OppurtinityCardProps> = (props) => {
  const {
    title,
    subtitle,
    mainActionText,
    imageUrl,
    secondaryActionText,
  } = props;
  return (
    <Card stretchVertically>
      <Card.Content>
        <Box
          direction="vertical"
          align="center"
          textAlign="center"
          height="300px"
        >
          <Box marginBottom="27px">
            <img
              height="79px"
              src={imageUrl}
              alt={title}
              data-hook={`opportunity-card-image-${title}`}
            />
          </Box>
          <Box marginBottom="2px">
            <Text
              weight="bold"
              size="medium"
              dataHook={`opportunity-card-title-${title}`}
            >
              {title}
            </Text>
          </Box>
          <Box marginBottom="22px" minHeight="72px">
            <Text dataHook={`opportunity-card-subtitle-${title}`}>
              {subtitle}
            </Text>
          </Box>
          <Box marginBottom={2}>
            <Button
              priority="secondary"
              dataHook={`opportunity-card-main-action-${title}`}
              onClick={props.onMainActionClick}
            >
              {mainActionText}
            </Button>
          </Box>
          {secondaryActionText && (
            <Box>
              <TextButton
                dataHook={`opportunity-card-secondary-action-${title}`}
                onClick={props.onSecondaryActionClick}
              >
                {secondaryActionText}
              </TextButton>
            </Box>
          )}
        </Box>
      </Card.Content>
    </Card>
  );
};
